import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IAssignmentDescription } from "../../utils/types/models";

export default createEntityReducer<IAssignmentDescription>(Endpoint.AssignmentDescriptions, Endpoint.AssignmentDescriptionsList);
